import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Card } from './ui/card';
import { useToast } from '../hooks/use-toast';
import { Lock, Save, Edit } from 'lucide-react';
import '../styles/AdminPanel.css';

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [editingSection, setEditingSection] = useState(null);
  const { toast } = useToast();

  // Mock password - in real app, this would be server-side
  const ADMIN_PASSWORD = 'garbabio2024';

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      toast({
        title: "Connexion réussie !",
        description: "Bienvenue dans le panneau d'administration.",
      });
    } else {
      toast({
        title: "Mot de passe incorrect",
        description: "Veuillez réessayer.",
        variant: "destructive"
      });
    }
  };

  const handleSave = (section, data) => {
    // Mock save - in real app, this would call API
    toast({
      title: "Modifications sauvegardées",
      description: `La section ${section} a été mise à jour.`,
    });
    setEditingSection(null);
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-login">
        <Card className="login-card">
          <div className="login-header">
            <Lock className="lock-icon" />
            <h2>Panneau d'Administration</h2>
          </div>
          
          <form onSubmit={handleLogin}>
            <Input
              type="password"
              placeholder="Mot de passe administrateur"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button type="submit" className="login-button">
              Se Connecter
            </Button>
          </form>
        </Card>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="container">
        <div className="admin-header">
          <h1>Panneau d'Administration</h1>
          <p>Gérez le contenu de votre portfolio</p>
        </div>
        
        <div className="admin-sections">
          <Card className="admin-section">
            <div className="section-header">
              <h3>Section Héro</h3>
              <Button 
                variant="outline"
                onClick={() => setEditingSection('hero')}
              >
                <Edit className="button-icon" />
                Modifier
              </Button>
            </div>
            
            {editingSection === 'hero' && (
              <div className="edit-form">
                <Input placeholder="Nom" defaultValue="Christiane YAO" />
                <Input placeholder="Titre" defaultValue="Cuisinière Vegan – Ambassadrice du Garba-Bio" />
                <Input placeholder="Sous-titre" />
                <div className="form-actions">
                  <Button onClick={() => handleSave('héro', {})}>
                    <Save className="button-icon" />
                    Sauvegarder
                  </Button>
                  <Button variant="outline" onClick={() => setEditingSection(null)}>
                    Annuler
                  </Button>
                </div>
              </div>
            )}
          </Card>
          
          <Card className="admin-section">
            <div className="section-header">
              <h3>Section À Propos</h3>
              <Button 
                variant="outline"
                onClick={() => setEditingSection('about')}
              >
                <Edit className="button-icon" />
                Modifier
              </Button>
            </div>
            
            {editingSection === 'about' && (
              <div className="edit-form">
                <Textarea placeholder="Biographie" rows={4} />
                <Input placeholder="Formation" />
                <Textarea placeholder="Inspirations" rows={3} />
                <div className="form-actions">
                  <Button onClick={() => handleSave('à propos', {})}>
                    <Save className="button-icon" />
                    Sauvegarder
                  </Button>
                  <Button variant="outline" onClick={() => setEditingSection(null)}>
                    Annuler
                  </Button>
                </div>
              </div>
            )}
          </Card>
          
          <Card className="admin-section">
            <div className="section-header">
              <h3>Section Garba-Bio</h3>
              <Button 
                variant="outline"
                onClick={() => setEditingSection('garbabio')}
              >
                <Edit className="button-icon" />
                Modifier
              </Button>
            </div>
            
            {editingSection === 'garbabio' && (
              <div className="edit-form">
                <Input placeholder="Titre" defaultValue="Garba-Bio : Ma Création Signature" />
                <Textarea placeholder="Description" rows={4} />
                <Input type="file" accept="image/*" multiple />
                <div className="form-actions">
                  <Button onClick={() => handleSave('Garba-Bio', {})}>
                    <Save className="button-icon" />
                    Sauvegarder
                  </Button>
                  <Button variant="outline" onClick={() => setEditingSection(null)}>
                    Annuler
                  </Button>
                </div>
              </div>
            )}
          </Card>
        </div>
        
        <div className="admin-actions">
          <Button variant="outline" onClick={() => window.location.href = '/'}>
            Retour au Site
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;